import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp, hover } from 'Styles/helpers';
import screen from 'superior-mq';
import Container from '../container';
import { Link } from '../../routes';
import Grid from '../grid';
import Button from '../button';
import Waves from '../waves';

const gridItemStyles = `
  align-self: center;

  &:last-of-type {
    ${screen.above(bp.tablet, `
      justify-self: end;
      align-self: center;
    `)}
  }

  ${screen.below(bp.tablet, `
    grid-column: 1 / -1;
  `)}
`;

const MoreLink = styled.a`
  ${props => hover(`color: ${props.theme.white}`)}
`;

const GdprRibbon = ({ showGDPR, acceptGDPR }) => (
  showGDPR
    ?
      <Ribbon>
        <RibbonContainer>
          <Grid>

            <Grid.Item span={8} styles={gridItemStyles}>
              <Text>We use cookies to give you the best possible experience on our website.
              If you continue without changing your settings, we presume that you
              accept receiving all of the cookies on our site. <Link route="/terms-and-conditions"><MoreLink>Read More</MoreLink></Link></Text>
            </Grid.Item>

            <Grid.Item span={4} styles={gridItemStyles}>
              <AcceptButton isdark onClick={acceptGDPR}>Accept</AcceptButton>
            </Grid.Item>

          </Grid>
        </RibbonContainer>

        <Waves
          position="bottom"
          alignment="bottom"
          height={100}
          color="#fff"
        />
      </Ribbon>
    : null
);

const Ribbon = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: auto;
  padding: 30px 0;
  color: #fff;
  background-color: ${props => props.theme.black};
  border-top: 1px solid ${props => props.theme.gdprBorderColor};

  p { font-size: 1.125rem; }

  ${screen.below(bp.tablet, `
    text-align: center;
  `)}
`;

const Text = styled.p`
  display: inline-block;
  margin: 0;
`;

const RibbonContainer = styled(Container)`
  position: relative;
  z-index: 9;
`;

const AcceptButton = styled(Button)`
  position: relative;
  z-index: 9;
  display: inline-block;

  ${screen.below(bp.tablet, `
    margin-top: 30px;
  `)}

  ${screen.below(bp.mobileSm, `
    margin-top: 20px;
  `)}
`;

GdprRibbon.propTypes = {
  showGDPR: PropTypes.bool,
  acceptGDPR: PropTypes.func,
};

export default GdprRibbon;
